import React, { useEffect, useMemo, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";
import { setDirection } from "../../i18n";
import DashboardSidebar from "./components/DashboardSidebar";
import { getDashboardNavItems } from "./dashboardNavConfig";

const DashboardLayout = () => {
  const { t, i18n } = useTranslation();
  const { logout } = useAuth();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const navItems = useMemo(() => getDashboardNavItems(t), [t, i18n.language]);

  useEffect(() => {
    setDirection(i18n.language);
    return () => setDirection(i18n.language);
  }, [i18n.language]);

  const handleLogout = () => {
    logout();
    window.location.href = "/";
  };

  return (
    <div dir="ltr" className="min-h-screen bg-slate-100 lg:h-screen lg:overflow-hidden">
      <div className="flex min-h-screen lg:h-full">
        <DashboardSidebar
          navItems={navItems}
          pathname={location.pathname}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          onLogout={handleLogout}
          t={t}
        />

        <main className="dashboard-admin flex-1 min-w-0 lg:h-full lg:overflow-y-auto p-3 pt-20 sm:p-4 sm:pt-20 lg:p-8 lg:pt-8">
          <div className="max-w-7xl mx-auto w-full">
            <div className="mb-4 flex flex-wrap items-start sm:items-center justify-end gap-3">
              <div className="flex items-center gap-2 sm:gap-3 ml-auto">
                {["en", "ar", "ku"].map((lang) => (
                  <button
                    key={lang}
                    type="button"
                    onClick={() => {
                      i18n.changeLanguage(lang);
                      localStorage.setItem("irqgyp_lang", lang);
                    }}
                    className={`px-3 py-1.5 rounded-lg text-sm border ${
                      i18n.language === lang
                        ? "bg-slate-900 text-white border-slate-900"
                        : "border-slate-300 hover:bg-white"
                    }`}
                  >
                    {lang.toUpperCase()}
                  </button>
                ))}
              </div>
            </div>

            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
